<template>
    <div class="rights" v-if='isratio'>
        <div class="divs">合并下载 <label style="font-size:12px;font-weight: 100;">(选择配色结果和辅助试剂)</label><span @click='close'>×</span></div>
        <div>
            <el-checkbox v-model="checked1" v-if='isshowo'>配色结果</el-checkbox>
        </div>
        <div>
            <el-checkbox v-model="checked2" v-if='isshowt'>辅助试剂</el-checkbox>
        </div>
        <div style="text-align: center;margin-top: 14px;">
            <el-button type="primary" size='mini' @click='merge'>合并下载</el-button>
        </div>
    </div>
</template>
<script>
import vm from '@/utils/event.js'
import {mergeUplode} from '@/view/product/api/luciferinmg'
export default {
    data(){
        return {
            checked1:false,
            checked2:false,
            names:{},
            isratio:false,
            isshowo:false,
            isshowt:false,
            disabled:true,
            list:[]
        }
    },
    created() {
        vm.$on('names',names=>{
            this.names = names
        })
        vm.$on('isratio',isratio=>{
            this.isratio = isratio
        })
        vm.$on('isshowo',isshowo=>{
            this.isshowo = isshowo
            this.checked1 = true
        })
        vm.$on('isshowt',isshowt=>{
            this.isshowt = isshowt
            this.checked2 = true
        })
        vm.$on("static",list=>{
            this.list = list
        })
    },
    watch:{
        $route(to,from){
            if(to.path =='/product/blendent' || to.path =='/product/reagent' ){
                if(this.isshowo == true || this.isshowt == true){
                    this.isratio = true
                }
            }else {
                this.isratio = false
            }
        }
    },
    methods:{
        close(){
            this.isratio = false
        },
        merge(){
            if(this.isshowo == false){
                this.$message.error('请选择配色结果')
                return false
            }
            if(this.isshowt == false){
                this.$message.error('请选择辅助试剂')
                return false
            }
            if(this.checked1 == true && this.checked2 == true){//合并下载
                let resultVO = {
                    results:this.names,
                    reagents:this.list
                }
                mergeUplode(resultVO).then((res)=>{
                    if(res.code==0){
                        window.location.href = res.data;
                        this.isratio = false
                        this.isshowo = false
                        this.isshowt = false
                    }
                })
            }else{
                this.$message.error('请选择勾选配色结果或者辅助试剂')
                return false
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.rights{
    padding: 10px;
    width: 270px;
    height: 150px;
    position: absolute;
    right: 0px;
    top: 120px;
    border: 1px solid #dedede;
    background: #ffffff;
    box-shadow: 1px 2px 5px #555;
    z-index: 99;
}
.divs{
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 6px;
}
.divs span{
        float: right;
        margin-right:6px;
        cursor: pointer;
        font-size: 20px;
        font-weight: 100;
    }
</style>


// WEBPACK FOOTER //
// src/components/rightMerge.vue